import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { RiPlantLine } from "react-icons/ri";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-lg w-full space-y-8 text-center">
        {/* 404 Number with Icon */}
        <div className="relative">
          <div className="text-[150px] md:text-[200px] font-extrabold text-darkGreen/10">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <RiPlantLine className="w-32 h-32 text-darkGreen animate-bounce" />
          </div>
        </div>

        {/* Error Message */}
        <div className="space-y-4">
          <h1 className="text-3xl font-bold text-gray-900">
            Oops! Page not found
          </h1>
          <p className="text-lg text-gray-600 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center px-6 py-3 border border-darkGreen text-darkGreen rounded-lg hover:bg-darkGreen hover:text-white transition-colors duration-200"
          >
            <FiArrowLeft className="mr-2" />
            Go Back
          </button>
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center justify-center px-6 py-3 bg-darkGreen text-white rounded-lg hover:bg-opacity-90 transition-colors duration-200"
          >
            Go to Homepage
          </button>
        </div>

        {/* Additional Help Text */}
        <div className="pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Need help? {" "}
            <a
              href="#"
              className="text-darkGreen hover:underline font-medium"
              onClick={(e) => {
                e.preventDefault();
                // Add your contact/support link handler here
              }}
            >
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;